import { render, staticRenderFns } from "./ItemsLoading.vue?vue&type=template&id=6b6979a3&scoped=true&"
import script from "./ItemsLoading.vue?vue&type=script&lang=js&"
export * from "./ItemsLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6979a3",
  null
  
)

export default component.exports